import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import { verificaAccesorios } from "../repository";
import accesoriosBadge from "../images/incluye_accesorios.png";

const ProductImageZoomViewer = (props) => {
  // Si el padre ya verificó accesorios, usa esa prop y evita una llamada extra.
  // Solo consulta por su cuenta cuando la prop no viene definida.
  const accesoriosFromProp = typeof props.tieneAccesorios === "boolean";
  const [tieneAccesorios, setTieneAccesorios] = useState(
    accesoriosFromProp ? props.tieneAccesorios : false
  );

  useEffect(() => {
    const codigo = props.item.Codigo;
    if (accesoriosFromProp || !codigo) return;

    let cancelado = false;
    verificaAccesorios(codigo)
      .then((response) => {
        // Fallo silencioso: si no es éxito, simplemente no se muestra el badge.
        if (!cancelado && response.status === "success") {
          setTieneAccesorios(Boolean(response.result && response.result.tieneAccesorios));
        }
      })
      .catch(() => {
        // El badge es informativo; un error no debe romper el zoom.
      });

    return () => {
      cancelado = true;
    };
  }, [props.item.Codigo, accesoriosFromProp]);

  const handleBackdropClick = (e) => {
    // Solo cerrar si se hace clic en el backdrop, no en el contenido
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  // Usar Portal para renderizar el modal fuera del card
  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal">
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            {props.item.Familia} {props.item.Codigo} (Zoom)
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            onClick={props.closeModal}
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body">
          {tieneAccesorios && (
            <img
              alt="Incluye accesorios: rebote y cubre polvo"
              src={accesoriosBadge}
              className="accesorios-badge"
            />
          )}
          <img
            alt={props.item.Codigo}
            src={props.imageSource}
            className="image-zoom-img"
          />
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductImageZoomViewer;
